import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SelectList } from "@common/selectList";
import { ArrowIcon } from "@common/assets/arrowIcon";
import { Props } from "./types";
import styles from "./styles.scss";

const notificationTypes = [
  "MENTION_IN_COMMENT",
  "ADDED_TO_TASK",
  "ADDED_TO_PROJECT",
  "ADDED_TO_EVENT",
  "DELAYED_TASK",
  "EXPORT_BI_FINISHED",
];

function ToolBar({ selectedTypes, setSelectedTypes }: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.toolBar}>
      <p className={styles.name}>{t("notificationsPage.filter.title")}</p>
      <SelectList rootClassName={styles.root} listClassName={styles.listRoot}>
        {({ isOpen, show, hide }) => ({
          input: (
            <div
              className={classNames(styles.input, { [styles.open]: isOpen })}
              onClick={isOpen ? hide : show}
            >
              {selectedTypes.length > 0 ? (
                <p className={styles.selection}>
                  {selectedTypes
                    .map((type) =>
                      t(`notificationsPage.filter.selection.${type}`),
                    )
                    .join(", ")}
                </p>
              ) : (
                <p className={styles.selection}>
                  {t("notificationsPage.filter.placeholder")}
                </p>
              )}
              <ArrowIcon className={styles.icon} />
            </div>
          ),
          list: (
            <div className={styles.body}>
              {notificationTypes.map((type, key) => (
                <div
                  key={key}
                  className={classNames(styles.type, {
                    [styles.selected]: selectedTypes.includes(type),
                  })}
                  onClick={() =>
                    setSelectedTypes(
                      selectedTypes.includes(type)
                        ? selectedTypes.filter((t) => t !== type)
                        : [...selectedTypes, type],
                    )
                  }
                >
                  <p>{t(`notificationsPage.filter.selection.${type}`)}</p>
                </div>
              ))}
              <div
                className={styles.button}
                onClick={() => setSelectedTypes([])}
              >
                <p>{t("notificationsPage.filter.clear")}</p>
              </div>
            </div>
          ),
        })}
      </SelectList>
    </div>
  );
}

export { ToolBar };
